import React, { memo } from "react";
import { formats } from "investira.sdk";
import { HighchartsReact } from "investira.react.charts";

const CenariosChart = memo((props) => {
  const { data = [] } = props;

  const processData = (data) => {
    const xMainData = [];

    data.forEach((xValue, xIndex) => {
      xMainData.push({
        name: xValue.cenario,
        y: xValue.impacto_financeiro,
        dataLabels: {
          color: "#FFFFFF", // Set the color of data labels to red
        },
        metadata: {
          name: xValue.cenario,
          ...xValue,
          impacto_financeiro: formats.formatNumber(
            xValue.impacto_financeiro,
            2,
            true,
            true
          ),
          //percentual: formats.formatNumber(item.percentual, 2, true)
        },
      });
    });

    return xMainData;
  };

  const xCenarios = processData(data).sort((a, b) => b.y - a.y);

  const xOptions = {
    chart: {
      type: "bar",
      height: "320px",
    },
    title: false,
    xAxis: {
      categories: xCenarios.map((xItem) => xItem.name),
      title: {
        text: null,
      },
      gridlineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      title: {
        text: "Impacto Financeiro",
        align: "high",
      },
      labels: { overflow: "justify" },
      gridlineWidth: 0,
    },
    plotOptions: {
      bar: {
        borderRadius: "50%",
        dataLabels: {
          enabled: true,
          // useHTML: true,
          formatter: function () {
            return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.metadata.impacto_financeiro}</span>`;
          },
          groupPadding: 0.1,
        },
      },
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000, // Set a high z-index for the tooltip
      },
      pointFormat: `Impacto Financeiro: <b>{point.metadata.impacto_financeiro}</b>`,
    },
    series: [
      {
        name: "Cenários",
        colorByPoint: true,
        data: xCenarios,
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600,
          },
        },
      ],
    },
    legend: {
      enabled: false,
    },
  };

  return <HighchartsReact options={xOptions} />;
});

export default CenariosChart;
